export default {
  'CONTROL' (state) {
    return state.control
  },
  'CONTROLS' (state) {
    return state.controls
  },
  'ITEMS' (state) {
    return state.items
  },
  'ITEM' (state) {
    return state.item
  },
  'GROUPS' (state) {
    return state.groups
  },
  'GROUP' (state) {
    return state.group
  }
}
